export const greet = () => {
    console.log("Hella brah");
};
